module.exports = __webpack_public_path__ + "static/media/NoDataFound.1bde6f8d.svg";